<template>
  <section class="local-lm-orders-title-mtop">
    <div class="lm-header">
      <h3
        v-if="orders && orders.length === 0 && hasSummited"
        class="subtitle is-5"
        v-t="'Orders.noResults'"
      />
      <h3
        v-if="orders && orders.length > 0"
        class="subtitle is-5"
        v-t="'Orders.results'"
      />
    </div>
    <div v-if="orders && orders.length">
      <div class="container local-lm-order-btns">
        <order-table-filter :type="type" />
        <b-button
          :icon-right="iconOrd"
          class="lm-default-btn--no-outline local-lm-xs-marginTop"
          @click.prevent="ord"
        />
        <b-button
          icon-right="file-download-outline"
          class="lm-default-btn--no-outline local-lm-xs-marginTop"
          @click.prevent="downloadExcel"
        >
          {{ $t("Orders.exportExcelFile") }}
        </b-button>
      </div>
      <b-table
        ref="table"
        :data="orders"
        :paginated="isPaginated"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :checkbox-position="checkboxPosition"
        :opened-detailed="defaultOpenedDetails"
        :checked-rows.sync="checkedRows"
        :total="totalCount"
        :current-page.sync="currentPage"
        backend-pagination
        per-page="13"
        detail-key="id"
        checkable
        detailed
        hoverable
        narrowed
        class="local-lm-orders-table"
        @click="(row) => closeAllOtherDetails(row)"
      >
        <b-table-column
          field="id"
          :label="$t('Orders.labelNumOrder')"
          width="150"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.orderId'"
              />
              {{ props.row.customerOrderCode }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.orderBo'"
              />
              {{ props.row.supplierOrderCode }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.store'"
              />
              {{ props.row.store.name }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="deliveryDate"
          width="180"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.numberVolumes'"
              />
              <volumes-tag
                :volumes="props.row.volumeTotal"
                :pallets="props.row.palletTotal"
                :equivalents="props.row.palletEquivalentNumber"
                :normalPalletEquivalent="props.row.palletEquivalentForPartner"
              />
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="250"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.labelWeight'"
              />
              <span
                v-html="
                  $t('Orders.volumeWeight', {
                    weight: props.row.weight,
                    volume: props.row.volume,
                  })
                "
              />
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.type'"
              >
              </span>
              {{ props.row.deliveryType }}
            </p>
            <p v-if="props.row.effectiveStatus === 'AWAITS_DISPATCH'">
              <span
                class="local-lm-orders-label"
                v-t="'Orders.supplierAvailableDate'"
              />
              {{ props.row.supplierCollectionRequestDate | stripHour }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="200"
          v-slot="props"
        >
          <div>
            <p v-if="props.row.effectiveStatus === 'AWAITS_DISPATCH'">
              <span
                class="local-lm-orders-label"
                v-t="'Orders.collectionDate'"
              />
              {{ props.row.partnerExpectedCollectionDate | stripHour }}
            </p>
            <p v-else>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.promisseDate'"
              />
              {{ props.row.deliveryDate | stripHour }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.deliveryPeriodDate'"
              />
              {{ _applySomeExceptions(props.row) }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.plate'"
              />
              {{ props.row.vehicleRegistration }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="200"
          v-slot="props"
        >
          <div>
            <p class="local-lm-orders-validations">
              <span
                class="local-lm-orders-label local-lm-orders-text-green"
                v-t="'Orders.littleState'"
              />
              <orders-status
                :status="props.row.effectiveStatus"
                :state="props.row.stateSeparation"
              />
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="30"
          field="props.row.customerOrderCode"
          v-slot="props"
        >
          <span>
            <b-button
              v-show="props.row.effectiveStatus !== 'AWAITS_DISPATCH'"
              icon-right="calendar"
              class="local-lm-btn-row"
              @click="openModal([ ...props.row ], actions.reschedule, props.row.deliveryDate)"
            />
          </span>
        </b-table-column>
        <b-table-column
          width="30"
          field="props.row.customerOrderCode"
          v-slot="props"
        >
          <span>
            <b-button
              v-if="props.row.effectiveStatus !== 'AWAITS_DISPATCH'"
              icon-right="clock-outline"
              class="local-lm-btn-row"
              @click="openModal([ ...props.row ], actions.schedule, props.row.deliveryDate)"
            />
            <b-button
              v-else
              icon-right="calendar-clock"
              class="local-lm-btn-row"
              @click="openModal([ ...props.row ], actions.rescheduleDateTime, props.row.supplierExpectedCollectionDate)"
            />
          </span>
        </b-table-column>
        <b-table-column
          width="30"
          field="props.row.customerOrderCode"
          v-slot="props"
        >
          <span>
            <b-button
              v-if="props.row.effectiveStatus !== 'AWAITS_DISPATCH'"
              icon-right="flag-outline"
              class="local-lm-btn-row"
              @click="openModal([ ...props.row ], actions.delivered, props.row.deliveryDate)"
            />
            <b-button
              v-else
              icon-right="check-outline"
              class="local-lm-btn-row"
              @click="openModal([ ...props.row ], actions.collected, props.row.deliveryDate)"
            />
          </span>
        </b-table-column>
        <b-table-column
          width="30"
          field="props.row.customerOrderCode"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp1')"
              type="is-dark"
            >
              <b-button
                icon-right="truck"
                class="local-lm-btn-header"
                @click.prevent="openModal(checkedRows, actions.regist)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="truck"
                class="local-lm-btn-row"
                @click.prevent="openModal([ ...props.row ], actions.regist, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          width="30"
          field="props.row.customerOrderCode"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp5')"
              type="is-dark"
              position="is-left"
            >
              <b-button
                icon-right="alert-outline"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.incidence)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="alert-outline"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.incidence, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>

        <template #detail="props">
          <section v-if="props.row.effectiveStatus !== 'AWAITS_DISPATCH'">
            <div class="columns local-lm-columns local-lm_green-vertical-line">
              <div
                class="column is-1 lm-default-bold"
                v-t="'Orders.clientDetails'"
              />
              <div class="column is-4">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.userName'"/>
                  <div>{{ props.row.customerLastName }}, {{ props.row.customerFirstName }}</div>
                </div>
              </div>
              <div class="column is-5">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.email'" />
                  <div v-t="props.row.customerMail" />
                </div>
              </div>
              <div class="column is-2">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.phone'" />
                  <div v-t="props.row.customerPhoneNumber" />
                </div>
              </div>
            </div>
            <div class="columns local-lm-columns local-lm_green-vertical-line">
              <div class="column is-1 lm-default-bold" />
              <div class="column is-6">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.address'" />
                  <div v-t="props.row.deliveryAddress" />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.postalCode'" />
                  <div v-t="props.row.deliveryPostalCode" />
                </div>
              </div>
              <div class="column is-4">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.city'" />
                  <div v-t="props.row.deliveryTown" />
                </div>
              </div>
            </div>
          </section>

          <section v-else>
            <div class="columns local-lm-columns local-lm_green-vertical-line">
              <div
                class="column is-1 lm-default-bold"
                v-t="'Orders.supplierDetails'"
              />
              <div class="column is-7">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.supplierName'" />
                  <div v-t="props.row.supplier.supplierName" />
                </div>
              </div>
              <div class="column is-4">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.numberVolumes'" />
                  <div v-t="_applyPalletsTranslations(props.row)" />
                </div>
              </div>
            </div>
            <div class="columns local-lm-columns local-lm_green-vertical-line">
              <div class="column is-1 lm-default-bold" />
              <div class="column is-6">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.supplierAddress'" />
                  <div v-t="props.row.supplier.address" />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.postalCode'" />
                  <div v-t="props.row.supplier.postalCode" />
                </div>
              </div>
              <div class="column is-4">
                <div class="local-lm-cell-details">
                  <label v-t="'Orders.city'" />
                  <div v-t="props.row.supplier.city" />
                </div>
              </div>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import OrdersStatus from '@/components/miscellaneous/OrdersStatus'
import OrderTableFilter from '@/components/filters/OrderTableFilter'
import VolumesTag from '@/components/VolumesTag'

export default {
  name: 'Edf',
  props: ['type'],
  computed: {
    ...mapGetters('orders', [
      'orders',
      'actions'
    ]),
    setActions () {
      return this.actions
    },
    totalCount () {
      return this.$store.getters['orders/totalCount']
    },
    currentPage: {
      get () {
        return this.$store.getters['filters/currentPage']
      },
      set (newVal) {
        this.$eventBus.$emit('onPageChange', newVal)
      }
    }
  },
  data () {
    return {
      hasSummited: false,
      hasData: false,
      checkboxPosition: 'left',
      isPaginated: true,
      isPaginationSimple: true,
      paginationPosition: 'top',
      defaultOpenedDetails: [],
      checkedRows: [],
      shouldOpen: true,
      iconOrd: 'sort-descending',
      defaultOrd: 'desc'
    }
  },
  components: {
    OrderTableFilter,
    VolumesTag,
    OrdersStatus
  },
  async mounted () {
    const filters = await this.$store.getters['filters/filtersSelected']
    const ok = await this.$store.dispatch('orders/getEdfOrders', { filters })
    if (!ok.level) return this.wrong(this.$t(ok.errorText))

    this.hasSummited = true

    this.$eventBus.$on('emptyOrders', () => {
      this.hasSummited = true
      this.hasData = true
    })

    this.$eventBus.$on('orders', async () => {
      this.checkedRows = []
      this.hasSummited = false
    })
  },
  methods: {
    closeAllOtherDetails (row) {
      if (!this.defaultOpenedDetails[0] || this.defaultOpenedDetails[0] === row.id) {
        if (this.shouldOpen) this.$refs.table.toggleDetails(row)
        this.shouldOpen = true
        return
      }

      if (this.defaultOpenedDetails[0] || this.defaultOpenedDetails[0] !== row.id) this.defaultOpenedDetails = [row.id]
    },
    async openModal (orders, type, date = '') {
      this.shouldOpen = false

      const data = {
        orders,
        type,
        date
      }

      switch (type) {
        case 'RESCHEDULE_DATE':
          this.$store.dispatch('filters/getReschedulesFilters')
          break
        case 'INCIDENCE':
          this.$store.dispatch('filters/getIncidentsFilters')
          break
        case 'SCHEDULE_PERIOD':
        case 'RESCHEDULE_DATE_TIME':
          this.$store.dispatch('filters/getSchedulesFilters')
          break
        case 'VEHICLE_REGISTRATION':
          this.$store.dispatch('user/getVehicles')
          break
        case 'DELIVERED':
          this.$store.dispatch('loading/start')

          const ordersIDs = orders.map(order => {
            const { id, customerOrderCode } = order

            return {
              id,
              customerOrderCode
            }
          })

          await this.$store.dispatch('filters/getListPods', ordersIDs)
          this.$store.dispatch('loading/stop')
          break
      }

      this.$store.dispatch('modal/launchModalWithData', data)
    },
    async downloadExcel () {
      const filters = await this.$store.getters['filters/filtersSelected']

      const file = await this.$store.dispatch('orders/downloadEdfFile', filters)
      if (!file.level) this.wrong(this.$t('Errors.somethingWrong'))
    },
    _applySomeExceptions ({ deliveryPeriod }) {
      // ! MOVIMENT-1338 apply this exception until these slots was deleted from the system
      const exceptions = ['MORNING', 'AFTERNOON']

      const arrStrings = deliveryPeriod
        .split(' ')
        .map(item => item.trim())

      const onlyDescriptionString = arrStrings
        .slice(0, arrStrings.length - 3)
        .join(' ')

      const applyCorrectString = (exceptions.includes(onlyDescriptionString)) ? this.$t(`Orders.${onlyDescriptionString}`) : onlyDescriptionString.toUpperCase()
      return `${applyCorrectString}`
    },
    _applyPalletsTranslations ({ volumeTotal, palletTotal, palletEquivalentNumber, palletEquivalentForPartner }) {
      const description = (key, data) => this.$t(`Orders.${key}`) + ` x ${data}`

      const showVolumes = volumeTotal ? description('volumeTotal', volumeTotal) : ''
      const showPallets = palletTotal ? description('palletTotal', palletTotal) : ''
      const showEquivalents = palletEquivalentNumber ? description('palletEquivalentNumber', palletEquivalentNumber) : ''
      const showNormalPalletEquivalent = palletEquivalentForPartner ? `= P ${palletEquivalentForPartner}` : ''

      return `${showVolumes} ${showPallets} ${showEquivalents} ${showNormalPalletEquivalent}`
    },
    ord () {
      if (this.defaultOrd === 'asc') {
        this.defaultOrd = 'desc'
        this.iconOrd = 'sort-descending'
      } else {
        this.defaultOrd = 'asc'
        this.iconOrd = 'sort-ascending'
      }

      this.$store.dispatch('filters/setOrd', this.defaultOrd)
      this.$eventBus.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Edf.vue